import Toast from './Toast';

export default {
  install: (Vue) => {
    Vue.component(Toast.name, Toast);
  }
}